export default function cep(cep) {

  if (typeof cep !== 'string') return;
  cep = cep.replace(/[^\d]+/g, '');
  if (cep.length > 5) cep = cep.substring(0, 5) + '-' + cep.substring(5, 8) ;
  return cep;

} // cep
